import { render, staticRenderFns } from "./ElementCarousel.vue?vue&type=template&id=51667a80&scoped=true"
import script from "./ElementCarousel.vue?vue&type=script&lang=js"
export * from "./ElementCarousel.vue?vue&type=script&lang=js"
import style0 from "./ElementCarousel.vue?vue&type=style&index=0&id=51667a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51667a80",
  null
  
)

export default component.exports